// Configuration for domain-based embedding restrictions
export interface DomainConfig {
  allowedDomains: string[];
  enableDomainRestrictions: boolean;
  logDomainInfo: boolean;
}

export const domainConfig: DomainConfig = {
  allowedDomains: [
    // Official domains
    'budget.iqd-pro.com',
    'www.hi-levelmezzanines.co.uk',

    // Development/testing domains
    'localhost',
    '127.0.0.1',
    'budget.test.iqd-pro.com',
    'hi-level.wp1.site',

    // Approved distributor domains
    'www.dexion-anglia.co.uk',
    'www.hmf-uk.com',
    'www.m-f-e.co.uk',
    'www.simplybusinessproducts.co.uk',
    'www.disbrey.co.uk',
    'mowbrayltd.co.uk',
    'www.nsiprojects.co.uk',
    'www.thedisbreygroup.co.uk',
    'pdindustrial.co.uk',
    'www.locators.co.uk',
    'www.imageinteriorsystems.co.uk',
  ],

  enableDomainRestrictions: true,

  logDomainInfo: true,
};
